import orange from '@material-ui/core/colors/deepOrange';
import { Theme } from '@material-ui/core/styles';
import createMuiTheme from '@material-ui/core/styles/createMuiTheme';

export class ThemeMuiProvider {
    public static provideTheme = (): Theme => {
        return createMuiTheme({
            palette: {
                primary: {
                    main: '#ee7203',
                },
                secondary: orange,
                type: 'light',
            },
        });
    };
}
